<template>
  <div class="flex-stretch note-content-editor-container" ref="container">
    <!-- <SelectionBar v-if="showSelectionBar" :selected-text="selectedText" :current-note="note" @link="createLink" @cancel="clearSelection"></SelectionBar> -->
    <keep-alive>
      <CKEditor
        ref="content"
        :value="currentContent"
        @input="onUpdate"
        @ready="onEditorReady"
        class="note-content-editor"
        @click="onClick"
        @contextedLinkAutocompleteUpdate="updateAutocomplete"
        @contextedLinkAutocompleteKeypress="handleAutocompleteKeypress"
      ></CKEditor>
    </keep-alive>
    <Autocomplete
      v-if="autocompleteText !== null"
      class="autocomplete mt-1"
      :style="autocompleteStyle"
      :text="autocompleteText"
      :currentNote="note"
      ref="autocomplete"
      @createLink="createLink"
    ></Autocomplete>
  </div>
</template>
<script>
import CKEditor from './CKEditor'
import debounce from 'lodash/debounce'
import { mdToHtml, htmlToMd } from '@/utils/markdown'
import goToNote from '@/mixins/go-to-note'
import Autocomplete from '@/components/Note/Autocomplete'
import CKEditorInspector from '@ckeditor/ckeditor5-inspector'

export default {
  props: ['content', 'note'],
  mixins: [goToNote],
  components: {
    CKEditor,
    Autocomplete
  },
  data() {
    return {
      editor: null,
      // selectionRange: '',
      currentContent: '',
      // textContent: '',
      autocompleteText: null,
      autocompleteStyle: {
        top: 0 + 'px',
        left: 0 + 'px'
      }
    }
  },
  created() {
    // performance.mark('created')
    this.setContent()
  },
  computed: {
    // breadcrumb() {
    //   return this.$store.getters.breadcrumb
    // },
    // showSelectionBar() {
    //   const nodes = this.selectionRange ? [...this.selectionRange.cloneContents().querySelectorAll('*')] : []
    //   const nodesContainsP = nodes.some(n => n.tagName === 'P')
    //   return this.selectedText.trim().length > 0 && !nodesContainsP && nodes.length <= 1
    // },
    // selectedText() {
    //   return this.selectionRange ? this.selectionRange.toString() : ''
    // },
    // contextedPrefix() {
    //   return this.$store.state.contextedPrefix
    // },
    // wordCount() {
    //   const wordCount = (this.textContent || '').split(' ').length
    //   return wordCount
    // }
  },
  methods: {
    updateAutocomplete({ position, autocompleteText }) {
      this.autocompleteText = autocompleteText
      const rectContainer = this.$refs.container.getBoundingClientRect()
      const { left: containerLeft, top: containerTop } = rectContainer
      const fontSize = parseInt(window.getComputedStyle(this.$refs.container).fontSize)
      this.autocompleteStyle = {
        top: `${position.top - containerTop + fontSize}px`,
        left: `${position.left - containerLeft}px`
      }
    },
    handleAutocompleteKeypress(event) {
      if (this.$refs.autocomplete) this.$refs.autocomplete.handleAutocompleteKeypress(event)
    },
    async getOrCreateNote(title) {
      const note = this.$store.getters.getNoteByTitle(title) || {}
      return note.id ? note : this.$store.dispatch('addNote', { title })
    },
    createLink(title) {
      const model = this.editor.model
      model.change(writer => {
        const currentPosition = model.document.selection.getFirstPosition()
        const node = [currentPosition.textNode, currentPosition.nodeBefore, currentPosition.nodeAfter]
          .find(node => node && (node.hasAttribute('contextedLinkAutocomplete') || node.hasAttribute('contextedLink')))
        const contextedLinkTextNode = writer.createText(title, { contextedLink: true })
        writer.insert(contextedLinkTextNode, node, 'after')
        model.enqueueChange(writer => {
          const { nextSibling } = contextedLinkTextNode
          if (!nextSibling || !nextSibling.data || !nextSibling.data.startsWith(']]')) writer.insertText(']]', model.document.selection.getFirstPosition())
        })
        if (node) writer.remove(node)
        writer.removeSelectionAttribute('contextedLink')
        writer.removeSelectionAttribute('contextedLinkAutocomplete')
        this.autocompleteText = null
      })
    },
    setContent() {
      const getHref = noteId => this.$router.resolve({ name: 'noteByContextion', params: { contextion: this.getContextion(noteId, true) } }).href
      const html = mdToHtml(this.content, this.$store, getHref)
      this.currentContent = html
      // performance.mark('set content')
    },
    async onClick({ event, data }) {
      const contextedLinkAttribute = data.target.getAttribute('data-contexted-link') || (data.target.parent && data.target.parent.getAttribute('data-contexted-link'))
      if (contextedLinkAttribute) {
        const contextedLinkNoteId = contextedLinkAttribute === 'true' ? (await this.getOrCreateNote(data.domTarget.textContent) || {}).id : contextedLinkAttribute
        const domEvent = data.domEvent
        if (contextedLinkNoteId && !domEvent.ctrlKey) {
          this.goToNote(contextedLinkNoteId, true)
          domEvent.preventDefault()
          domEvent.stopPropagation()
        }
      }
    },
    // onEnter({ event, data }) {
    //   const { domEvent } = data
    //   if ((domEvent.ctrlKey || domEvent.shiftKey) && domEvent.code === 'Enter' && this.showSelectionBar) {
    //     this.wrapSelection()
    //     event.stop()
    //   }
    // },
    onEditorReady(editor) {
      // performance.mark('editor ready')

      // performance.measure('measure created - set content', 'created', 'set content')
      // performance.measure('measure set content - editor ready', 'set content', 'editor ready')
      // performance.measure('measure mount ckeditor - editor created', 'mount ckeditor', 'editor created')
      // console.log(performance.getEntriesByType('measure').map(({ name, duration }) => ({ name, duration })))
      // performance.clearMarks()
      // performance.clearMeasures()

      if (process.env.NODE_ENV === 'development') CKEditorInspector.attach(editor, { isCollapsed: true })
      this.editor = editor
      // this.$nextTick(() => {
      //   this.textContent = this.editor.editing.view.domRoots.get('main').textContent
      // })
      editor.editing.view.focus()

      // let mouseDown = false
      // let keyDown = false
      // document.body.onmousedown = () => {
      //   mouseDown = true
      // }
      // document.body.onmouseup = () => {
      //   mouseDown = false
      //   getSelectionRange()
      // }
      // document.onkeydown = () => {
      //   keyDown = true
      // }
      // document.onkeyup = () => {
      //   keyDown = false
      //   getSelectionRange()
      // }
      // const getSelectionRange = debounce(() => {
      //   const isEditor = document.activeElement === this.editor.editing.view.domRoots.get('main')
      //   if (isEditor && (!mouseDown && !keyDown)) {
      //     this.getSelectionRange()
      //   }
      // }, 50, { leading: true, trailing: true })
      // document.addEventListener('selectionchange', getSelectionRange)
    },
    wrapSelection() {
      // this.editor.model.change(writer => {
      //   for (const range of this.editor.model.document.selection.getRanges()) {
      //     writer.setAttribute('contextedHighlight', true, range)
      //   }
      // })
    },
    // clearSelection() {
    //   this.selectionRange = null
    // },
    // getSelectionRange() {
    //   const selection = window.getSelection()
    //   this.selectionRange = selection.rangeCount > 0 ? selection.getRangeAt(0) : null
    // },
    // createLink({ note, redirect }) {
    //   this.editor.editing.view.focus()
    //   const model = this.editor.model
    //   model.change(writer => {
    //     const rangeInRoot = writer.createRangeIn(this.editor.model.document.getRoot())
    //     for (const item of rangeInRoot.getItems()) {
    //       const highlighted = item.getAttribute('contextedHighlight')
    //       if (highlighted) {
    //         writer.setAttributes({
    //           contextedLink: note.id,
    //           contextedTitle: note.title
    //         }, item)
    //         writer.removeAttribute('contextedHighlight', item)
    //         const node = item.is('textProxy') ? item.textNode : item
    //         writer.setSelection(node, 'after')
    //       }
    //     }
    //     model.enqueueChange(writer => {
    //       this.updateContent(true)
    //       if (redirect) this.goToNote(note.id, true)
    //     })
    //   })
    // },
    onUpdate: debounce(function () {
      this.updateContent()
    }, 500, { maxWait: 5000 }),
    updateContent(syncedWithDom = false) {
      const getHtml = syncedWithDom => {
        const getHtmlFromDom = () => this.editor.editing.view.domRoots.get('main')
        const getHtmlFromEditor = () => this.editor.getData()
        return syncedWithDom ? getHtmlFromEditor() : getHtmlFromDom()
      }
      try {
        const updatedContentHtml = getHtml(syncedWithDom)
        if (updatedContentHtml) {
          // this.textContent = updatedContentHtml.textContent
          const updatedContentMd = htmlToMd(updatedContentHtml, this.$store)
          this.$emit('update', updatedContentMd)
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  watch: {
    // showSelectionBar() {
    //   if (!this.showSelectionBar) {
    //     this.editor.model.change(writer => {
    //       const rangeInRoot = writer.createRangeIn(this.editor.model.document.getRoot())
    //       for (const item of rangeInRoot.getItems()) {
    //         if (item.getAttribute('contextedHighlight')) {
    //           writer.removeAttribute('contextedHighlight', item)
    //         }
    //       }
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
.note-content-editor-container {
  position: relative;
}
.note-content-editor p {
  margin-top: 0px !important;
}
.contexted-link {
  color: $primary !important;
  font-weight: bold;
  cursor: pointer;
  // position: relative;
  // margin: 0 0.7rem;
}
// .contexted-link:before,
// .contexted-link:after {
//   color: $gray-400;
//   font-weight: normal;
//   // position: absolute;
// }
// .contexted-link:before {
//   content: "[[";
//   left: -0.7rem;
// }
// .contexted-link:after {
//   content: "]]";
//   right: -0.7rem;
// }
.contexted-link:hover {
  background-color: $gray-200;
}
// .contexted-link:before {
//   font-family: "Font Awesome 5 Brands";
//   content: "\f3f5";
//   display: inline-block;
//   padding-right: 3px;
//   // vertical-align: middle;
//   font-weight: 900;
//   font-size: 80%;
//   color: $gray-500;
// }

.highlight-text {
  background-color: $secondary;
  color: white;
}

.ck-placeholder::before {
  color: $gray-500 !important;
}

.ck-editor,
.ck-editor__main,
.ck-content {
  flex-direction: column !important;
  flex-grow: 1 !important;
  display: flex !important;
  box-shadow: none !important;
  outline: none;
  border-width: 0px !important;
  padding: 0px !important;
}
.note-content-editor {
  line-height: 1.8;
  font-weight: 300;
}
.note-content-editor h1,
.note-content-editor h2,
.note-content-editor h3 {
  padding: 0;
  margin: 0 !important;
}
.note-content-editor h1 {
  font-size: 1.9rem;
  font-weight: 600;
}
.note-content-editor h2 {
  font-size: 1.7rem;
  font-weight: 500;
}
.note-content-editor h3 {
  font-size: 1.5rem;
  font-weight: 400;
}
.note-content-editor h4 {
  font-size: 1.2rem;
  font-weight: 300;
}
.note-content-editor p {
  font-size: 1.1rem;
}
a {
  cursor: pointer;
}
// [contenteditable=true]:before {
//   color: $gray-500 !important;
//   content: 'Click here to start typing...';
//   display: block; /* For Firefox */
// }
.autocomplete {
  position: absolute;
}
</style>
